import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, BookOpen, Lock } from "lucide-react";
import type { LucideIcon } from "lucide-react";

interface ComingSoonProps {
  title: string;
  description?: string;
  icon: LucideIcon;
  backgroundImage?: string;
}

export function ComingSoon({ title, description, icon: Icon, backgroundImage }: ComingSoonProps) {
  const navigate = useNavigate();

  return (
    <div className="min-h-dvh relative flex items-center justify-center p-4">
      {/* Blurred background */}
      {backgroundImage && (
        <div className="absolute inset-0 z-0">
          <img src={backgroundImage} alt="" className="w-full h-full object-cover  opacity-30" />
        </div>
      )}
      <div className="absolute inset-0 z-0 mesh-gradient opacity-60" />

      {/* Glass card overlay */}
      <div className="relative z-10 w-full max-w-lg glass-card rounded-xl p-8 md:p-12 text-center space-y-6 fade-in-up">
        {/* Icon */}
        <div className="mx-auto w-16 h-16 rounded-xl bg-primary/10 flex items-center justify-center">
          <Icon className="w-8 h-8 text-primary" />
        </div>

        {/* Title */}
        <h1 className="text-2xl md:text-3xl font-bold text-foreground">{title}</h1>

        {/* Badge */}
        <Badge className="bg-accent/15 text-accent border-accent/30 text-sm px-4 py-1.5">
          <Lock className="w-3.5 h-3.5 mr-1.5" />
          Bientôt disponible
        </Badge>

        {/* Description */}
        <p className="text-muted-foreground leading-relaxed">
          {description || "Cette fonctionnalité est en cours de développement. Nous recherchons activement des financements pour la rendre accessible à tous."}
        </p>

        {/* Funding mention */}
        <p className="text-sm italic text-muted-foreground/70">
          Recherche de financement en cours
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 pt-2">
          <Button
            variant="outline"
            className="flex-1"
            onClick={() => navigate("/")}
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Retour à l'accueil
          </Button>
          <Button
            className="flex-1"
            onClick={() => navigate("/resources")}
          >
            <BookOpen className="w-4 h-4 mr-2" />
            Découvrir les ressources
          </Button>
        </div>
      </div>
    </div>
  );
}
